import { TextField } from '@mui/material';
import { Component } from 'react';

export default class NomeInput extends Component {
    render() {
        return (
            <TextField
                {...this.props.props}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe um nome" : null}
                size="small"
                variant="outlined"
                name="nome"
                label={'Nome' + (this.props.required ? '*': '')}
                value={this.props.value}
                onChange={e => this.props.onChange ? this.props.onChange(e.target.value) : {}} />
        );
    }
}